let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("czKM7")]).then(() => parcelRequire('9fBrm'));